/*
  Конец загрузки - зелёный блок «Готово» (вариант А макета, решение владельца
  19.10.2026).

  Указание владельца: «сделать финал очевиднее - сейчас не отличить от
  зависания». Прежний итог был строкой в общей плашке, и конец загрузки
  терялся среди остальных сообщений. Здесь он отдельным блоком: что записано,
  цифрами в ряд, сколько заняло, и два очевидных следующих шага - открыть
  реестр или загрузить другой файл.

  Неудача сюда не приходит: её показывает `Notice` с причиной и тем, что
  делать, - так же, как любой отказ кабинета.

  Общий для всех шагов загрузки: шаг передаёт заголовок, цифры своего итога и
  совет, блок добавляет время записи из `useUploadFlow`.
*/

import { Link } from 'react-router-dom'

const NUMBER = new Intl.NumberFormat('ru-RU')

// «1 мин 4 с» - как в макете; меньше минуты - «14 с».
export function took(seconds) {
  if (seconds === undefined || seconds === null) return null
  const whole = Math.max(1, Math.round(seconds))
  const minutes = Math.floor(whole / 60)
  return minutes ? `${minutes} мин ${whole % 60} с` : `${whole} с`
}

function value(item) {
  return typeof item === 'number' ? NUMBER.format(item) : item
}

export default function UploadEnd({ title, facts, advice, seconds, onAgain, children }) {
  const time = took(seconds)
  const shown = facts.filter(([, item]) => item !== null && item !== undefined)
  return (
    <div className="notice notice--ok upload-end" role="status">
      <div className="notice__what">{title}</div>
      <ul className="upload-end__facts">
        {shown.map(([label, item]) => (
          <li key={label}>
            {label}: <b>{value(item)}</b>
          </li>
        ))}
        {time ? (
          <li>
            Заняло: <b>{time}</b>
          </li>
        ) : null}
      </ul>
      {advice ? <div className="notice__do">{advice}</div> : null}
      {children}
      <div className="row">
        <Link className="button" to="/registry">
          Открыть реестр
        </Link>
        {onAgain ? (
          <button type="button" className="button button--quiet" onClick={onAgain}>
            Загрузить другой файл
          </button>
        ) : null}
      </div>
    </div>
  )
}
